import Vue from 'vue'

Vue.prototype.$money = function (amount) {
  if (!amount) { amount = 0 }
  if (isNaN(amount)) {
    amount = 0
  }
  amount = parseFloat(amount).toFixed(2)
  return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
Vue.prototype.$count = function (amount) {
  if (!amount) { amount = 0 }
  if (isNaN(amount)) {
    amount = 0
  }
    return amount.toLocaleString()
}
Vue.prototype.$crawler = function (arr, str) {
  let result = [];
  for (let i = 0; i < arr.length; i++ ) {
    let item  = JSON.stringify(arr[i])
    let found  = new RegExp(str, 'i').test(item);
    if(found ){
      result.push(arr[i])
    }
  }
  return result;
}
Vue.prototype.$pagination = function (arr, size) {
  let result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
}
Vue.prototype.$capitalize =  function(string){
  return string.split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

Vue.prototype.$randomString = function(length) {
  var result = '';
  var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"
  for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
  return result;
}
Vue.prototype.$paddingZeroLeft  = function(num, size) {
    var s = num+"";
    while (s.length < size) s = "0" + s;
    return s;
}

Vue.prototype.$IsNum = function (input) {
  if (isNaN(parseFloat(input)) || input == null) {
    return 0
  }
  input = parseFloat(input).toFixed(2)
  return parseFloat(input)
}
Vue.prototype.$Filter = function (input) {
  var data = input.trim() 
  //[^a-zA-Z ]
  return data.replace(/[^\w\s]/gi, '')
}
Vue.prototype.$printThis = function () {
    window.print()
}
Vue.prototype.$groupBy = key => array =>
  array.reduce((objectsByKeyValue, obj) => {
    const value = obj[key]
    objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj)
    return objectsByKeyValue
  }, {})

Vue.prototype.$StatusColor = function (status) {
  switch(status){
    case 'Drawn':
      return "#313131"
    case 'Ready':
      return "info"
    case 'Close':
        return "warning"
    case 'Open':
      return "success"
      case 'claimed':
        return "success"
        case 'unclaimed':
          return "warning"
    default:
        return "info"
  }    
}
